






















import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { AustralianState } from '@shared/types/locations';
import { UCButtonGroup, UCIcon } from '@shared/ui';

import AMXButton from '~/components/AMXButton.vue';
import AMXRadioButtonGroup from '~/components/AMXRadioButtonGroup.vue';
import SidebarSubheading from '~/components/VehiclesSideBar/SidebarSubheading.vue';

import InputLicencePlate from './InputLicencePlate.vue';

interface Validation {
  rego: string | null;
  ausState: string | null;
}

interface VehiclesRegoSearchFormEmitProps {
  emit: {
    (event: 'submit', rego: string, state: string): void;
  };
}

interface VehiclesRegoSearchFormProps {
  loading?: boolean;
  error?: string;
}

export default defineComponent({
  components: {
    InputLicencePlate,
    UCIcon,
    AMXButton,
    SidebarSubheading,
    AMXRadioButtonGroup,
    UCButtonGroup,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props: VehiclesRegoSearchFormProps, { emit }: VehiclesRegoSearchFormEmitProps) {
    const inputRego = ref('');
    const ausState = ref('');
    const validation = ref<Validation>({
      rego: null,
      ausState: null,
    });

    const ausStatesOptionList = computed(() =>
      Object.values(AustralianState).map((state) => ({ value: state, text: state })),
    );

    const handleInput = (e: Event) => {
      inputRego.value = (e.target as HTMLInputElement).value.replace(/[^a-z\d]/gi, '');
    };

    const onAusStateChanged = (value: string) => {
      ausState.value = value;
    };

    const regoError = computed(() => props.error || validation.value.rego);

    const handleSubmit = () => {
      let hasError = false;

      if (!inputRego.value) {
        validation.value.rego = 'Please enter a rego';
        hasError = true;
      }
      if (!ausState.value) {
        validation.value.ausState = 'Please select a state';
        hasError = true;
      }

      if (hasError) {
        return;
      }

      emit('submit', inputRego.value, ausState.value);
    };

    watch([inputRego, ausState], ([newRego, newAusState], [oldRego, oldAusState]) => {
      if (newRego !== oldRego) {
        validation.value.rego = null;
      }
      if (newAusState !== oldAusState) {
        validation.value.ausState = null;
      }
    });

    return {
      inputRego,
      validation,
      handleInput,
      handleSubmit,
      onAusStateChanged,
      ausStatesOptionList,
      ausState,
      regoError,
    };
  },
});
